module.exports = __webpack_public_path__ + "static/rosaria-0bc048aa7cb0c8f44d94c79e3bc6c7ec.png";